import api from "@/services/api";
import { PremiumVoucherInfo } from "@/types/premium/PremiumVoucher";

class GetPremiumVouchers {
  execute = async () => {
    const response = await api().get("/associate-premium/vouchers");
    return response.data as PremiumVoucherInfo;
  };
}

export { GetPremiumVouchers };
